/**
 * Contrato da API do painel da equipe (/api/equipe). Tipos compartilhados entre API e web.
 */
import { ETAPAS, } from './dominio.js';
/** Etapas que a equipe pode escolher ao avançar manualmente (enquanto os robôs não existem). */
export const ETAPAS_MANUAIS = ETAPAS.filter((e) => ETAPAS.indexOf(e) >= ETAPAS.indexOf('aprovacao'));
/** Mensagem pronta para a equipe enviar ao cliente ou a um sócio, por WhatsApp ou e-mail, com um clique. */
export const MODELOS_PRONTOS = [
    'taxa_junta',
    'assinatura_socio',
    'documento_faltando',
    'mudanca_etapa',
    'acompanhamento',
];
//# sourceMappingURL=equipe.js.map